import React from "react"
import { RequiredSymbol } from "../../common/components/various"
import { InputError } from "../../common/components/inputError";

interface FileInputProps {
	label?: string;
	onChange: (e: FileList | null) => void;
	style?: React.CSSProperties;
	required?: boolean | undefined;
	accept?: string[];
	error?: string;
	multiple?: boolean;
}

export class FileInput extends React.Component<FileInputProps>
{
	render() {
		const { error, label, required, accept } = this.props;
		const acceptedFormats = accept?.join(",");

		let wrapperClass = label ? "mb-3" : "";
		if (this.props.error && this.props.error.length > 0)
			wrapperClass += " has-error";

		return (
			<div className={wrapperClass}>
				{label && <label className="form-label">{label}</label>} {required && <RequiredSymbol />}
				<div className="input-group" style={{ width: "100%" }}>
					<input
						type="file"
						accept={acceptedFormats}
						onChange={e => this.props.onChange(e.target.files)}
						multiple={this.props.multiple}
					/>
				</div>
				{acceptedFormats && <div style={{ fontSize: "0.8em" }}>Formati accettati {acceptedFormats}</div>}
				<InputError error={error} />
			</div>);
	}
}

export default FileInput;